import { TableRow, styled } from '@mui/material';

export const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'isNew' && prop !== 'dueStatus' && prop !== 'isCompleted'
  })(({ theme, isNew, dueStatus, isCompleted }) => {
    let backgroundColor, hoverColor, borderColor;
    
    // If task is completed, use white background
    if (isCompleted) {
      backgroundColor = '#ffffff';
      hoverColor = '#fafafa';
      borderColor = '#e0e0e0';
    } else {
      switch (dueStatus) {
        case 'overdue':
          backgroundColor = '#ffebee';
          hoverColor = '#ffcdd2';
          borderColor = '#ffcdd2';
          break;
        case 'due-soon':
          backgroundColor = '#fff3e0';
          hoverColor = '#ffe0b2';
          borderColor = '#ffe0b2';
          break;
        case 'on-time':
          backgroundColor = '#e8f5e8';
          hoverColor = '#c8e6c9';
          borderColor = '#c8e6c9';
          break;
        default:
          backgroundColor = '#f5f5f5';
          hoverColor = '#eeeeee';
          borderColor = '#eeeeee';
      }
    }
    
    return {
      backgroundColor,
      '&:hover': {
        backgroundColor: hoverColor
      },
      '& .MuiTableCell-root': {
        backgroundColor,
        borderBottom: `1px solid ${borderColor}`
      }
    };
  });
  